<template>
    <div id="full-calendar" :class="`table${this.hasDrag ? ' has-drag' : ''}`">
        <div
                class="table-head"
        >
            <div
                    id="month-drop-zone"
                    class="table-cell"
                    v-on:drop="drop($event, 'month')"
                    v-on:dragover="dragOver"
                    v-on:dragenter="dragEnterMonth"
                    v-on:dragleave="dragLeaveMonth"
            ></div>
            <div
                    class="table-cell table-th"
                    scope="col"
                    v-for="(day, i) in daysOfWeek"
                    :key="day"
                    v-on:drop="drop($event, 'day', null, null, day)"
                    v-on:dragover="dragOver"
                    v-on:dragenter="dragEnter"
                    v-on:dragleave="dragLeave"
                    :data-col="i + 2"
            >
                <span>{{ day }}</span>
                <span class="table-th-highlight" :style="`height: ${height}px;`"></span>
            </div>
        </div>

        <div class="table-body">
            <div class="table-row" v-for="w in 6" :key="`w-${w}`">
                <div
                        class="table-cell table-th"
                        scope="row"
                        v-on:drop="drop($event, 'week', w)"
                        v-on:dragover="dragOver"
                        v-on:dragenter="dragEnter"
                        v-on:dragleave="dragLeave"
                >
                    <span>{{ calendarDates[w-1][0].week() }}</span>
                </div>
                <td
                        :data-current="isThisMonth(calendarDates[w-1][d-1]) ? 'current-month' : undefined"
                        v-for="d in 7"
                        :key="`d-${d}`"
                        :class="[{'table-cell': true, 'table-td': true, 'previous-month': (calendarDates[w-1][d-1] < currentMonth)}, {'next-month':calendarDates[w - 1][d - 1] >= nextMonth},{'active': isSameDate(calendarDates[w-1][d-1],today)}]"
                        :data-isbeforetoday="isBeforeToday(calendarDates[w-1][d-1].format('YYYY-MM-DD')) ? 'yes' : 'no'"
                        v-on:drop="drop($event, 'date', w, d)"
                        v-on:dragover="dragOver"
                        v-on:dragenter="dragEnter($event, isBeforeToday(calendarDates[w-1][d-1].format('YYYY-MM-DD')))"
                        v-on:dragleave="dragLeave"
                >
                    <!-- 'reserved-cell' -->
                    <div :class="['calendar-cell', {'reserved-cell' : isDroppedDate(calendarDates[w-1][d-1].format('YYYY-MM-DD'))}]">
                        <div class="label-day">{{calendarDates[w-1][d-1].date()}}</div>
                        <div class="event-place-holder"></div>
                        <div class="reserved-cell__tooltip" v-if="isDroppedDate(calendarDates[w-1][d-1].format('YYYY-MM-DD'))"> <!-- v-tooltip="{data: `Reserved : ${getCurrentTemplateName}`, arrowPosition: 'right'}" -->
                            <span class="reserved-name">{{ getDtName(calendarDates[w-1][d-1].format('YYYY-MM-DD')) }}</span>
                            <span class="reserved-cell__close" @click="removeReserved(calendarDates[w-1][d-1].format('YYYY-MM-DD'))"></span>
                        </div>
                        <ScheduledCard
                                v-if="scheduledDataPerDate[calendarDates[w-1][d-1].format('YYYYMMDD')]"
                                :scheduledData="scheduledDataPerDate[calendarDates[w-1][d-1].format('YYYYMMDD')]"
                                :key="calendarDates[w-1][d-1].format('YYYY-MM-DD')"
                                :isDroppable="true"
                        />
                    </div>
                </td>
            </div>
        </div>
        <!-- Generate button -->
        <Button v-if="!!reservedSlot.length" :empty="false" class="float-button" @click="generate">Generate planning</Button>
    </div>
</template>

<script>
    import moment from "moment";
    import ScheduledCard from "./ScheduledCard";
    import Constants from "@/store/constants";
    import EventBus from "@/eventbus";
    import {HTTP} from "@/utils/http";
    import Apis from "@/apis/index";
    import {safeObj} from "@/utils/safeObj";
    import {mapState} from "vuex";


    export default {
        name: "FullCalendar",
        components: {ScheduledCard},
        created() {
            this.calculateDates();
        },
        mounted() {
            this.calculateDates();
            EventBus.$on("dragStart", this.dragStart);
            EventBus.$on("dragEnd", this.dragEnd);

            this.height = parseInt(this.$el.getBoundingClientRect().height) + 12;

            this.portletBody = document.querySelector(
                ".m-portlet__body:not(.no-padding"
            );
            //this.portletBody.style.overflow = "visible";
        },
        beforeDestroy() {
            this.portletBody.setAttribute("style", "");
            EventBus.$off("dragStart", this.dragStart);
            EventBus.$off("dragEnd", this.dragEnd);
        },
        props: {
            date: Object,
            scheduledData: {type: Array}
        },
        data() {
            return {
                safeObj,
                hasDrag: false,
                height: 0,
                currentMonth: new Date(),
                currentDayTemplate: null,
                nextMonth: new Date(),
                calendarDates: null,
                today: moment().startOf("day"),
                daysOfWeek: Constants.daysOfWeek,
                portletBody: null,
                reservedSlot: []
            };
        },
        watch: {
            date: function () {
                this.calculateDates();
            }
        },
        computed: {
            ...mapState({
               allDt: state => state.results.stationDayTemplateListResult.data.dataItem.items
            }),
            getCurrentTemplateName(){
              return safeObj(this.currentDayTemplate) && this.currentDayTemplate.name
            },
            scheduledDataPerDate() {
                var records = {};
                if (!this.scheduledData) {
                    return records;
                }
                for (var i = 0; i < this.scheduledData.length; i++) {
                    var record = this.scheduledData[i];
                    records[moment(record.date).format("YYYYMMDD")] = record;
                }
                return records;
            },
            getCalendarCellDate(week, weekDay) {
                try {
                    return this.calendarDates[week - 1][weekDay - 1];
                } catch (e) {
                }
            },
            getAllDt(){
                return safeObj(this.allDt) && this.allDt
            }
        },
        methods: {
            getDtName(date){
                const currentReservedDt = this.reservedSlot.length && this.reservedSlot.filter(e => e.date === date)[0];
                const currentSourceDt = this.getAllDt.filter(dt => dt.uid === currentReservedDt.dayTemplateUid)[0];
                return currentSourceDt.name

            },
            isBeforeToday(currentDate){
                return moment(currentDate).isBefore();
            },
            isSameOfAfterToday(currentDate) {
                return moment(currentDate).isSameOrAfter(moment().format('YYYY-MM-DD'));
            },
            removeReserved(date){
                this.reservedSlot = this.reservedSlot.filter(e => e.date !== date)
            },
            isThisMonth(date) {
                const currentMonth = moment(this.currentMonth).startOf('month');
                return moment(currentMonth).isSame(date, 'month');
            },
            isSameDate(dateA, dateB) {
                return dateA.diff(dateB, "minutes") === 0;
            },
            calculateDates() {
                var tmpMonth = this.date || moment().startOf("month");
                this.currentMonth = moment(tmpMonth);
                this.nextMonth = moment(this.currentMonth).add(1, "month");
                var workDate = this.currentMonth;

                var firstDayOfMonth = workDate.day();
                var daysOfPrevMonthToAdd = this.getWeekDayIndex(
                    this.currentMonth.format("dddd")
                );

                this.calendarDates = [];

                for (let day = 0; day < 42; day++) {
                    const cellDate = moment(this.currentMonth);

                    if (day < daysOfPrevMonthToAdd) {
                        // Previous month dates
                        this.calendarDates.push(
                            cellDate.subtract(daysOfPrevMonthToAdd - day, "days")
                        );
                    } else {
                        this.calendarDates.push(
                            cellDate.add(day - daysOfPrevMonthToAdd, "days")
                        );
                    }
                }

                this.calendarDates = this.chunkArray(this.calendarDates, 7);
            },
            async generate() {
                try {
                    const response = await HTTP.post(Apis.planning.scheduleBatch, {
                      //dayTemplateUid: this.currentDayTemplate.uid,
                      stationUid: this.$store.state.currentStationUid,
                      dates: this.reservedSlot
                    });
                    if (response) {
                        // remove class reserved of selected days
                        this.reservedSlot = [];
                        EventBus.$emit("calendarNeedUpdate");
                    }
                } catch (e) {
                    console.log("error in planning.schedule :", e);
                }
            },
            async addDayTemplate(dates) {
                // get legitimate days
                const dateFromToday = dates.filter(e => this.isSameOfAfterToday(e));
                const final = [];
                const remove = [];

                // build object for each of these days
                dateFromToday.forEach(d => {
                    final.push({
                        dayTemplateUid: this.currentDayTemplate.uid,
                        date: d
                    })
                });

                // remove duplicate date of previous selected slot
                this.reservedSlot.forEach((e, i) => {
                    if(dateFromToday.includes(e.date)){
                       remove.push(i)
                    }
                });
              for (var i =remove.length-1; i > -1; i--){
                this.reservedSlot.splice(remove[i], 1)
              }

                // set final result
                !!final.length && this.reservedSlot.push(...final)
            },
            dragOver(e) {
                e.preventDefault();
            },
            dragEnter(e, beforeToday) {
                if(!beforeToday){
                    const $target = e.currentTarget;
                    const scope = $target.getAttribute("scope");
                    $target.classList.add("has-drag");


                    if (scope) {
                        if (scope === "row") {
                            $target.parentElement.classList.add("has-drag");
                        }

                        if (scope === "col") {
                            const dataCol = $target.getAttribute("data-col");
                            const $els = this.$el.querySelectorAll(
                                `.table-td:nth-child(${dataCol})`
                            );

                            for (let i = 0; i < $els.length; i++) {
                                const $el = $els[i];
                                $el.classList.add("col-drag");
                            }

                            this.height = parseInt(this.$el.getBoundingClientRect().height) + 12;
                        }
                    }
                }
            },
            dragEnterMonth(e) {
                const daysInMonth = document.querySelectorAll('td[data-current="current-month"]');
                daysInMonth.forEach(day => day.classList.add('has-drag'))
            },
            dragLeaveMonth() {
                const daysInMonth = document.querySelectorAll('td[data-current="current-month"]');
                daysInMonth.forEach(day => day.classList.remove('has-drag'))
            },
            dragLeave(e) {
                const $target = e.currentTarget;
                const scope = $target.getAttribute("scope");
                $target.classList.remove("has-drag");

                if (scope) {
                    if (scope === "row") {
                        $target.parentElement.classList.remove("has-drag");
                    }

                    if (scope === "col") {
                        const dataCol = $target.getAttribute("data-col");
                        const $els = this.$el.querySelectorAll(
                            `.table-td:nth-child(${dataCol})`
                        );

                        for (let i = 0; i < $els.length; i++) {
                            const $el = $els[i];
                            $el.classList.remove("col-drag");
                        }
                    }
                }
            },
            isDroppedDate(currentDate){
                if(!!this.reservedSlot.length){
                    return !!this.reservedSlot.find(e => {
                        //const current = e.date;
                        return currentDate === e.date && this.isSameOfAfterToday(currentDate)
                        // return current.find(d => {
                        //     return currentDate === d && this.isSameOfAfterToday(currentDate) // moment(currentDate).isSameOrAfter(moment('YYYY-MM-DD')) //!this.isBeforeToday(currentDate)
                        // })
                    })
                }
                //return !!this.reservedSlot.length && !!this.reservedSlot.find(e => e.dates === currentDate.date);
            },
            drop(e, type, w, d, slug) {
                this.dragLeave(e);
                switch (type) {
                    case "day":
                        this.dropDay(slug);
                        break;
                    case "week":
                        this.dropWeek(w);
                        break;
                    case "month":
                        this.dropMonth();
                        break;
                    default:
                        this.dropDate(w, d);
                        break;
                }

                this.$store.dispatch('Templates/setDraggedDayTemplateUid', null)
            },
            // Drop on each day of the week
            dropDay(day) {
                const month = this.currentMonth.format("MMMM");

                let dates = this.calendarDates
                    .map(w => {
                        let week = w.filter(d => {
                            return d.format("MMMM") === month && d.format("dddd") === day;
                        });

                        if (week[0]) {
                            return week[0]
                        }
                    })
                    .filter(d => {
                        return d;
                    });

                 try {
                  dates = this.filterConstrainedDates(dates)
                } catch (e) {
                  console.error(e)
                } finally {
                  this.addDayTemplate(dates.map(d => d.format("YYYY-MM-DD")) );
                }
            },
            // Drop on the whole week
            dropWeek(w) {
                let dates = this.calendarDates[w - 1];

                try {
                  dates = this.filterConstrainedDates(dates)
                } catch (e) {
                  console.error(e)
                } finally {
                  this.addDayTemplate(dates.map(d => d.format("YYYY-MM-DD")));
                }
            },
            dropMonth() {
                // Get number of days on current month
                const daysInMonth = moment(this.currentMonth).daysInMonth(); // example: 31
                // Get first day of current month
                const startOfMonth = moment(this.currentMonth).startOf('month');
                // Create an array with first day of month as first value
                let days = [startOfMonth];

                // For earch days in current month, add 1 day to start of month and populate 'days' array
                for (let i = 0; i < daysInMonth - 1; i++) {
                    days = [...days, moment(startOfMonth).add(i + 1, 'day')]
                }

                try {
                  days = this.filterConstrainedDates(days)
                } catch (e) {
                  console.error(e)
                } finally {
                  this.dragLeaveMonth();
                  this.addDayTemplate(days.map(day => day.format('YYYY-MM-DD')))
                }
            },
            // Drop on a specific date
            dropDate(w, d) {
                let dates = [this.calendarDates[w - 1][d - 1]];

                 try {
                  dates = this.filterConstrainedDates(dates)
                } catch (e) {
                  console.error(e)
                } finally {
                  this.addDayTemplate(dates.map(d => d.format("YYYY-MM-DD")));
                }
            },
            dragStart(e, item, type) {
                this.hasDrag = true;
                if (type === "dayTemplate") {
                    this.currentDayTemplate = item;
                }
            },
            dragEnd(e) {
                this.hasDrag = false;
                //this.currentDayTemplate = null;
            },
            // Helperss
            getWeekDayIndex(d) {
                for (let i = 0; i < this.daysOfWeek.length; i++) {
                    const day = this.daysOfWeek[i];
                    if (day === d) {
                        return i;
                    }
                }
            },
            chunkArray(array, size) {
                var tempArray = [];

                for (var i = 0; i < array.length; i += size) {
                    var myChunk = array.slice(i, i + size);
                    // Do something if you want with the group
                    tempArray.push(myChunk);
                }

                return tempArray;
            },
            filterConstrainedDates(dates) {
              const dayTemplate = this.$store.state.Templates.templatesByUid[this.$store.state.Templates.draggedDayTemplateUid]

              return dates.filter(date => {
                return dayTemplate.timeConstraints
                  .every(constraint => {
                    return this.isDayOfWeekBitEnabled(constraint, date.isoWeekday())
                      && this.isDayOfMonthBitEnabled(constraint, date.month() + 1, date.date())
                  })
              })
            },
            isDayOfWeekBitEnabled(constraint, dayOfWeek) {
              const mask = Math.pow(2, dayOfWeek - 1)

              return (constraint.dayOfWeekMask & mask) > 0
            },
            isDayOfMonthBitEnabled(constraint, month, dayOfMonth) {
              let propName = "dayOfMonthMask" + (month < 10 ? "0" : "") + month
              let domValue = constraint[propName]
              let mask = Math.pow(2, dayOfMonth - 1)

              return (domValue & mask) > 0
            }
        }
    };
</script>


<style lang="scss" scoped>
    @import "@/assets/css/_colors.scss";
    // Table
    .table {
        height: 100%;
        border: none;
        margin: 0;

        // Drag
        &.has-drag {
            .table-td,
            .table-th {
                * {
                    pointer-events: none;
                }
            }
        }
    }

    // Head
    // -----------------------------------------------------------------------------
    .table-head {
        display: flex;
        height: 45px;

        .table-cell {
            border: 0;
        }
    }

    // Body
    // -----------------------------------------------------------------------------
    .table-body {
        // position: relative;
        height: calc(100% - 45px);

        .table-cell:not(:first-child) {
            border-top: 1px solid #d2d2d2;
        }
    }

    // Row
    // -----------------------------------------------------------------------------
    .table-row {
        display: flex;
        align-items: stretch;
        height: (100 / 6) * 1%;


        &::before {
            content: "";
            display: none;
            position: absolute;
            z-index: 1;
            top: -6px;
            left: -6px;
            width: calc(100% + 12px);
            height: calc(100% + 12px);
            border-radius: 3px;
            border: 1px solid #d2d2d2;
            background-color: #fff;
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
            pointer-events: none;
            border-right-color: rgba(0, 0, 0, 0);
        }

        &.has-drag {
            position: relative;

            .table-cell {
                z-index: 2;
                border-top-color: rgba(0, 0, 0, 0);

                .calendar-cell {
                    background-color: #fff;
                }
            }

            &::before {
                display: block;
            }
        }
    }

    // Cells (td / th)
    // -----------------------------------------------------------------------------
    .table-cell {
        width: 13.9%;
        height: 100%;
        border-top: 0;
        border-right: 1px solid #d2d2d2;

        &:first-child {
            width: 30px;
            flex-shrink: 0;
        }
    }

    // Th
    // -----------------------------------------------------------------------------
    .table-th {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        padding: 12px 5px 10px;
        color: #aaaaaa;
        font-size: 13px;
        line-height: 16px;
        text-align: center;

        &[scope="row"] {
            padding: 0;
            vertical-align: middle;
        }

        &-highlight {
            position: absolute;
            top: -6px;
            left: -6px;
            z-index: -1;
            width: calc(100% + 12px);
            height: calc(100% + 12px);
            background-color: #fff;
            border-radius: 3px;
            border: 1px solid #d2d2d2;
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
            pointer-events: none;
        }

        &[scope="col"].has-drag {
            z-index: 1;

            .table-th-highlight {
                display: block;
            }
        }
    }

    // Td
    // -----------------------------------------------------------------------------
    .table-td {
        position: relative;
        padding: 10px;

        &:last-child {
            border-right: 0;
        }

        .calendar-cell {
            overflow: hidden;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;

            .label-day {
                padding: 5px;
                color: #292c33;
                font-size: 13px;
                font-weight: 400;
                line-height: 16px;
                text-align: center;
            }
        }

        // Highlight
        &::before {
            content: "";
            display: none;
            position: absolute;
            top: -6px;
            left: -6px;
            width: calc(100% + 12px);
            height: calc(100% + 12px);
            z-index: -1;
            border: 1px solid #d2d2d2;
            border-radius: 3px;
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
            background-color: #fff;
            pointer-events: none;
        }

        &.active {
            background: rgba(0, 0, 0, 0.2);
        }

        // Fade cell
        &.previous-month,
        &.next-month {
            &::before {
                background-color: #f7f8f9;
            }

            .calendar-cell {
                background-color: #f7f8f9;

                .label-day {
                    color: #abacaf;
                }
            }
        }

        // Drag over
        &.has-drag {
            z-index: 1;

            &::before {
                display: block;
            }
        }

        &.col-drag {
            z-index: 3;
            border-right-color: rgba(0, 0, 0, 0);

            .calendar-cell {
                background-color: #fff;
            }
        }
    }

    .drop-indication {
        transition: all .2s ease-out;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
        transform: scale(1.03);
    }

    .reserved-cell {
        background-color: rgba(128, 128, 128, .4) !important;
        background-image: repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255, 255, 255, .2) 35px, rgba(255, 255, 255, .2) 70px) !important;
        position: relative;
        .reserved-cell__tooltip{
            position: absolute;
            height: 100%; width: 100%;
            z-index: 1;
            .reserved-cell__close{
                position: absolute;
                top: 0; right: 0;
                z-index: 1;
                width: 20px; height: 20px;
                cursor: pointer;
                &:after{
                    font-family: "Font Awesome 5 Free";
                    content: "\f00d";
                    font-style: normal;
                    font-weight: 900;
                    color: #0a6aa1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .reserved-name{
                position: absolute;
                height: 100%;
                width: 100%;
                background: rgba(#ff6a00, .9);
                z-index: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                color: #fff;
                font-size: 12px;
                padding: 5px;
                transition: all .3s ease;
                transform: translate3d(-100%,0,0);
            }
            &:hover{
                .reserved-name{
                    transform: translate3d(0%,0,0);
                }
            }
        }
    }
    .float-button{
        position: sticky;
        bottom: 10px;
        left: 10px;
    }
</style>
